import { render } from "./UserStatusEdit.vue?vue&type=template&id=347a32fa&scoped=true"
import script from "./UserStatusEdit.vue?vue&type=script&lang=js"
export * from "./UserStatusEdit.vue?vue&type=script&lang=js"

import "./UserStatusEdit.vue?vue&type=style&index=0&id=347a32fa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-347a32fa"

export default script